import { useCallback, type FC, type ReactNode } from 'react';
import { Events, Link } from 'react-scroll';

import { useIsMobile, useMenuToggleDispatch } from 'src/utils';

type Props = {
  className?: string;
  children: ReactNode;
  to: string;
  ['aria-label']?: string;
};

const useOnClick = () => {
  const { dispatch } = useMenuToggleDispatch();
  return useCallback(() => {
    Events.scrollEvent.register('end', () => {
      dispatch &&
        dispatch({
          type: 'set',
          payload: { isToggled: false },
        });
      Events.scrollEvent.remove('end');
    });
  }, [dispatch]);
};

export const ScrollAnchor: FC<Props> = ({
  className,
  children,
  to,
  'aria-label': ariaLabel,
}) => {
  const isMobile = useIsMobile();
  const withoutHashTo = to.substring(1);
  const onClick = useOnClick();
  return (
    <Link
      className={className ?? ''}
      to={withoutHashTo}
      aria-label={ariaLabel}
      smooth={true}
      duration={300}
      onClick={onClick}
      offset={isMobile ? -120 : -100}
    >
      {children}
    </Link>
  );
};

export default ScrollAnchor;
